'use strict';

$(() => {
    const $carousels = $('.article-carousel-component__items');
    $carousels.each((i, carousel) => {
        const $carousel = $(carousel);
        const $wrapper = $carousel.find('.article-carousel-component__wrapper');

        const settings = {
            prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-arrow-left-hover icon-size-xl"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="icon icon-arrow-right-hover icon-size-xl"></i></button>',
            useTransform: false,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        };

        $wrapper.slick(settings);
    });
});
